import { getFeatureToggleClient } from '../../infra/featureToggles'

export function isExtensionEnabled(): boolean {
  return getFeatureToggleClient().variation('Worklayer.Extension', false)
}

export function isExtensionBillingEnabled(): boolean {
  return getFeatureToggleClient().variation('Worklayer.ExtensionBilling', false)
}
